import React from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-20" data-testid="payment-cancel-page">
      <div className="max-w-lg w-full bg-white rounded-3xl p-10 card-tactile text-center">
        <Heart className="w-14 h-14 text-bsn-gold mx-auto mb-6" />
        <h1 className="font-serif text-3xl font-semibold text-bsn-midnight">No worries — nothing was charged</h1>
        <p className="text-bsn-sapphire/80 mt-4 leading-relaxed">
          Your checkout was cancelled and your cart is still saved. Whenever you're ready, we'll be right here.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/shop" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full btn-gold font-semibold" data-testid="cancel-shop-link">
            <ArrowLeft className="w-5 h-5" /> Back to Shop
          </Link>
          <Link to="/" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-bsn-midnight text-bsn-parchment font-semibold hover:bg-bsn-navy transition-colors" data-testid="cancel-home-link">
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
}
